const ACTIONS = {
  GET: "get",
  SUBMIT: "submit",
  FINAL_SUBMIT: "final_submit",
  DRAFT_SUBMIT: "draft_submit",
  GET_SUBMISSION: "getSubmission",
  SUBMIT_SCRIPT: "submitScript",
  CHARACTER_SUBMIT: "charactersubmit",
  VOTE: "vote",
  GET_VOTING_THRESHOLD: "getVotingThreshold",
  GET_ARCHIVED_SUBMISSIONS: "getArchivedSubmissions",
  GET_VIMEO_TICKET: "getVimeoUploadTicket",
};

export { ACTIONS };
